export default __webpack_public_path__ + "static/media/onboarding-aside-mb.4e554e3a.png";